import TagManager from 'react-gtm-module';

const useGtmStepHook = () => {
  const gtmStepEvent = (eventName, stepLabel, eventData) => {
    TagManager.dataLayer({
      dataLayer: {
        event: eventName,
        step_label: stepLabel,
        ...eventData,
      },
    });
  };

  return {
    gtmStepEvent,
  };
};

export default useGtmStepHook;
